import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// 样式文件
import './styles/global.css'

// 错误抑制工具
import { initErrorSuppression } from './utils/errorSuppression'

// 立即处理 ResizeObserver 错误，在任何其他代码执行前
(function() {
  // 立即禁用 ResizeObserver 错误
  window.addEventListener('error', function(event) {
    if (event.message && event.message.includes('ResizeObserver loop completed')) {
      event.preventDefault()
      event.stopPropagation()
      return false
    }
  }, true)

  // 立即禁用 Promise rejection 错误
  window.addEventListener('unhandledrejection', function(event) {
    if (event.reason && event.reason.message && 
        event.reason.message.includes('ResizeObserver loop completed')) {
      event.preventDefault()
      return false
    }
  })
})()

// 初始化错误抑制
initErrorSuppression()

// 创建应用实例
const app = createApp(App)

// 注册Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// Vue应用级错误处理
app.config.errorHandler = (err, vm, info) => {
  if (err.message && (
    err.message.includes('ResizeObserver loop completed') ||
    err.message.includes('ResizeObserver loop limit exceeded')
  )) {
    // 忽略ResizeObserver错误
    return
  }
  // 其他错误正常处理
  console.error('Vue应用错误:', err, info)
}

// 全局错误处理 - 处理webpack-dev-server overlay错误
window.addEventListener('error', (event) => {
  if (event.error?.message?.includes('ResizeObserver loop completed')) {
    event.preventDefault()
    return false
  }
}, true)

// 处理Promise rejection错误
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.message?.includes('ResizeObserver loop completed')) {
    event.preventDefault()
    return false
  }
})

// 使用插件
app.use(router)
app.use(ElementPlus)

// 挂载应用
app.mount('#app')

console.log('🚄 ROFC车站管理系统启动成功')
